import { CirclePause, CirclePlay, Trash2 } from 'lucide-react';
import { Button } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import type { ProductStatus } from '../product.ts';
import styles from './ProductEditor.module.css';

export type EditorActionsProps = {
  status: ProductStatus | null;
  pending: boolean;
  onSave: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  onArchive: () => void;
};

export const EditorActions = ({
  status,
  pending,
  onSave,
  onActivate,
  onDeactivate,
  onArchive,
}: EditorActionsProps) => {
  const { t } = useTranslation();
  const activate = (
    <Button
      icon={<CirclePlay size={20} aria-hidden="true" />}
      variant="outline"
      disabled={pending}
      onClick={onActivate}
    >
      {t('productEditor.publish')}
    </Button>
  );
  if (status === 'archived')
    return (
      <div className={styles['actions']}>
        <span className={styles['archivedNotice']}>{t('productEditor.archivedNotice')}</span>
        <span className={styles['spacer']} />
        {activate}
      </div>
    );
  return (
    <div className={styles['actions']}>
      {status === null ? null : (
        <Button
          icon={<Trash2 size={20} aria-hidden="true" />}
          variant="dangerGhost"
          disabled={pending}
          onClick={onArchive}
        >
          {t('catalog.delete')}
        </Button>
      )}
      <span className={styles['spacer']} />
      {status === 'draft' ? activate : null}
      {status === 'active' ? (
        <Button
          icon={<CirclePause size={20} aria-hidden="true" />}
          variant="outline"
          disabled={pending}
          onClick={onDeactivate}
        >
          {t('productEditor.deactivate')}
        </Button>
      ) : null}
      <Button disabled={pending} onClick={onSave}>
        {pending ? t('common.saving') : t('common.save')}
      </Button>
    </div>
  );
};
